// extracted by mini-css-extract-plugin
module.exports = {"container":"RoleCreate_container__3WqSp","formGroup":"RoleCreate_formGroup__2OQyn"};